import React, { useState, useEffect, useContext, useRef } from 'react';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import ModelsTable from '../../components/models-table';
import BrandsTable from '../../components/brands-table';
import TextField from "@material-ui/core/TextField/TextField";
import PageLayout from "../../components/page-layout";
import { makeStyles } from "@material-ui/styles";
import { useGetDeviceModels, useGetBrands, useCreateBrand, useCreateModel } from '../../services/device';
import { ModalContext } from '../../contexts/modal';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';

export default function Models() {

    const { setOpen, setContent } = useContext(ModalContext)
    const getDeviceModels = useGetDeviceModels();
    const getBrands = useGetBrands();
    const [models, setModels] = useState([]);
    const [brands, setBrands] = useState([]);

    async function handleDeviceModels() {
        const models = await getDeviceModels()
        setModels(models)
    }
    async function handleBrands() {
        const brands = await getBrands()
        setBrands(brands)
    }

    useEffect(() => {
        handleDeviceModels()
        handleBrands()
    }, [])

    function openModelModal() {
        const cont = <CreateModelModal />
        setContent(cont)
        setOpen(true)
    }

    function openBrandModal() {
        const cont = <CreateBrandModal />
        setContent(cont)
        setOpen(true)
    }

    const classes = useStyles()

    return (
        <PageLayout pageTitle="مدل‌ها و برند‌ها">
            <Grid container spacing={3}>
                <Grid item xs={10} md={8}>
                    <Button variant="contained" color="primary" className={classes.button} onClick={openModelModal}>افزودن مدل</Button>
                    <ModelsTable models={models} />
                </Grid>
                <Grid item xs={10} md={4}>
                    <Button variant="contained" color="primary" className={classes.button} onClick={openBrandModal}>افزودن برند</Button>
                    <BrandsTable brands={brands} />
                </Grid>
            </Grid>
        </PageLayout>
    );
}





const useStyles = makeStyles(theme => ({

    button: {
        marginBottom: theme.spacing(3)
    },

}));


function CreateModelModal() {
    const nameRef = useRef()
    const ramRef = useRef()
    const storageRef = useRef()
    const [brand, setBrand] = useState('')
    const [allBrands, setAllBrands] = useState([])
    const getDeviceBrands = useGetBrands()
    const createModel = useCreateModel()

    const { setOpen } = useContext(ModalContext)

    async function fetchData() {
        const brands = await getDeviceBrands()
        setAllBrands(brands)
    }
    const classes = useStyles1()

    useEffect(() => {
        fetchData()
        return () => {
        }
    }, [])

    async function onClick() {
        await createModel(nameRef.current.value, ramRef.current.value, storageRef.current.value, brand.tag)
        setOpen(false)
    }

    return (
        <form autoComplete={false}>

            <div className={classes.input}>
                <TextField label="نام مدل" variant="filled" size="small" fullWidth
                    inputRef={nameRef} />
            </div>
            <FormControl variant="filled" size="small" fullWidth className={classes.select}>
                <InputLabel >نام برند</InputLabel>
                <Select
                    fullWidth
                    label='برند'
                    placeholder='برند'
                    value={brand}
                    onChange={e => setBrand(e.target.value)}
                >{allBrands.map(b => <MenuItem value={b}>{b.name}</MenuItem>)}
                </Select>
            </FormControl>
            <div className={classes.input}>
                <TextField label="رم" variant="filled" size="small" type="numeric" fullWidth
                    inputRef={ramRef} />
            </div>
            <div className={classes.input}>
                <TextField label="حافظه داخلی" variant="filled" size="small" type="numeric" fullWidth
                    inputRef={storageRef} />
            </div>

            <Button variant="contained" color="primary" className={classes.button}
                fullWidth onClick={onClick}>ایجاد</Button>
        </form>
    )

}

function CreateBrandModal() {
    const nameRef = useRef()

    const createBrand = useCreateBrand()
    const { setOpen } = useContext(ModalContext)
    const [error, setError] = useState(false)

    const onClick = async () => {
        try {
            await createBrand(nameRef.current.value)
            setOpen(false)
        } catch {
            setError(true)
        }
    }

    const classes = useStyles1()

    return (
        <form autoComplete={false}>

            <div className={classes.input}>
                <TextField label="نام برند" variant="filled" size="small" fullWidth
                    inputRef={nameRef} error={error} />
            </div>
            <Button variant="contained" color="primary" className={classes.button}
                fullWidth onClick={onClick}>ایجاد</Button>
        </form>
    )

}



const useStyles1 = makeStyles(theme => ({

    root: {
        textAlign: 'center',
        padding: theme.spacing(5, 5, 3, 5),
        borderColor: theme.palette.primary.main
    },
    input: {
        margin: theme.spacing(2, 0),
    },
    button: {
        marginTop: theme.spacing(4),
        color: 'white'
    },
    text: {
        marginTop: theme.spacing(10)
    }
}));
